import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import ApplicantCreateSelf from "Communication/ApiClasses/ApplicantCreateSelf";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleApplicantCreateSelf(action) {
  console.log(action);
  yield put(
    doLoadingStart(
      STRINGS.JOIN_APPLICANT.API_KEYS.APPLICANT_CREATE_SELF,
      action.data.message ? action.data.message : null
    )
  );
  const applicantCreateSelf = new ApplicantCreateSelf(action.data);
  try {
    const result = yield call(applicantCreateSelf.getData);
    yield put({
      type: actionTypes.APPLICANT_CREATE_SELF_SUCCESS,
      response: result,
      formData: { ...action.requestData },
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.APPLICANT_CREATE_SELF_ERROR,
      error: e.message,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.JOIN_APPLICANT.API_KEYS.APPLICANT_CREATE_SELF)
    );
  }
}

// watcher
function* applicantCreateSelfWatcherSaga() {
  yield takeLatest(
    actionTypes.APPLICANT_CREATE_SELF,
    handleApplicantCreateSelf
  );
}

export default applicantCreateSelfWatcherSaga;
